export enum ApplicationName {
  SaasApi = "SaasApi",
  Hsase = "Hsase",
}
